<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card has-text-white">
        {{ getTitle }}
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-6-widescreen is-5-fullhd">
            <left-information
              :facture="facture"
              :datePaiementBase="datePaiementBase"
              :labelIntervenant="getLabelIntervenant"
              :sousTypes="getSousTypesIntervenant"
              @updateDatePaiement="$emit('updateDatePaiement', $event)"
              @tiersUpdated="$emit('tiersUpdated')">
            </left-information>
          </div>
          <div class="column is-6-widescreen is-offset-0-widescreen is-5-fullhd is-offset-2-fullhd">
            <right-information :facture="facture">
            </right-information>
          </div>
        </div>
        <div class="mgt-40px">
          <liste-lignes-ventes
            :dcf="facture"
            :commandeAchatARapprocher="commandeAchatARapprocher"
            :sens="constantes.SENS_ACHAT"
            :isCreditNote="isAvoir"
            :error="false"
            :breadcrumb="[]"
            :categoriesProduct="getCategoriesProduct"
            :is-avoir-libre="isAvoirLibre"
            @calcul="calcul">
          </liste-lignes-ventes>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <commentaires
        :afficherCommentaireFacture="false"
        :type="facture.type"
        :devisCommandeFacture="facture">
      </commentaires>
    </div>
  </div>
</template>

<script>
import leftInformation from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/leftInformation';
import rightInformation from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/rightInformation';
import listeLignesVentes from '@/components/devisCommandes/editionDevisCommande/listeLignesVentes';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import { SENS_ACHAT, MODULE_ACHAT } from '@/configuration/devisConf';
import commentaires from '@/components/bodac/dcf/addEditDcf/commentaires/commentaires';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/facture/factureConf';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';
import { CATEGORIE_IMPRESSION_AFFICHE } from '@/configuration/catalogue/produitConf';
import { TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON, LISTE_SOUS_TYPE_FOURNISSEURS_PAGES } from '@/configuration/tiers/tiersConf';

export default {
  name: 'factureInformation',
  props: {
    facture: {
      type: Object,
      required: true,
    },
    datePaiementBase: {
      type: Date,
      required: false,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: false,
    },
    isAvoirLibre: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      constantes: {
        SENS_ACHAT,
      },
    };
  },
  components: {
    leftInformation,
    rightInformation,
    listeLignesVentes,
    commentaires,
  },
  methods: {
    calcul() {
      calculCommandeDevis(this.facture);
    },
  },
  computed: {
    isAvoir() {
      return [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE].includes(this.facture.sousType);
    },
    getTitle() {
      if (this.facture.module === MODULE_ACHAT) return this.$t('addEditFactureAchat.informations.title');
      if (this.facture.module === MODULE_TLPE) return this.$t('editionTitreRecette.titreRecette.title');
      return this.$t('editionCreationDepenseBailleur.depenseBailleur.title');
    },
    getLabelIntervenant() {
      if (this.facture.module === MODULE_ACHAT) return this.$t('addEditFactureAchat.informations.labelIntervenant');
      return '';
    },
    getSousTypesIntervenant() {
      if (this.facture.module === MODULE_ACHAT) {
        return LISTE_SOUS_TYPE_FOURNISSEURS_PAGES
          .map(el => el.code)
          .filter(el => el !== TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON);
      }
      return [];
    },
    getCategoriesProduct() {
      if (this.facture.module === MODULE_ACHAT) {
        return [CATEGORIE_IMPRESSION_AFFICHE];
      }
      return [];
    },
  },
};
</script>

<style scoped>

</style>
